var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 11.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm9-3.982a.497.497 0 0 0-.5-.495h-2.849a5.878 5.878 0 0 0-1.093-1.872l1.557-2.665A9.026 9.026 0 0 0 11.656.5l-1.562 2.673A6.134 6.134 0 0 0 9 3.07c-.374 0-.739.039-1.094.103L6.344.5a9.026 9.026 0 0 0-3.459 1.986l1.557 2.665a5.878 5.878 0 0 0-1.093 1.872H.5c-.276 0-.5.222-.5.495v2.964c0 .273.224.495.5.495h2.849a5.878 5.878 0 0 0 1.093 1.872l-1.557 2.665A9.026 9.026 0 0 0 6.344 17.5l1.562-2.673c.355.064.72.103 1.094.103.374 0 .739-.039 1.094-.103l1.562 2.673a9.026 9.026 0 0 0 3.459-1.986l-1.557-2.665a5.878 5.878 0 0 0 1.093-1.873H17.5c.276 0 .5-.22.5-.494V7.518Z",
  clipRule: "evenodd"
})));
export default SvgIconSettings;